import { useQuery } from "@tanstack/react-query";

import { axiosInstance } from "../lib/axios";

import type { FeaturesConfigType } from "../constants/feature";

type FeatureConfigResponseType = {
  features: FeaturesConfigType;
};

const FEATURE_CONFIG_QUERY_KEY = ["feature-config"] as const;

const fetchFeatureConfig = async () => {
  return axiosInstance.get<FeatureConfigResponseType>("/feature/config");
};

export const useFetchFeatureConfig = () => {
  return useQuery({
    queryKey: FEATURE_CONFIG_QUERY_KEY,
    queryFn: fetchFeatureConfig,
    select: (data) => {
      return data.data.features;
    },
  });
};
